import { connect } from 'react-redux';
import { ILocalization } from '../../localization/definitions/types';
import { RootState } from '../../store';
import SusyButton from '../shared/buttons/SusyButton';
import { SignOutIcon } from '../shared/icons/icons';
import './Navbar.css';

interface INavbarSignOutItem {
    handleSignOut: () => void;
    localization: ILocalization;
}

const NavbarSignOutItem = ({
    handleSignOut,
    localization,
}: INavbarSignOutItem) => {
    const navbarSignOutItemLocalization =
        localization.localizationStrings.susy.navbar.navbarSignOutItem;

    return (
        <>
            <SusyButton
                text={navbarSignOutItemLocalization.logoutNavItem}
                onClickHandler={() => handleSignOut()}
                icon={<SignOutIcon />}
                size='medium'
                classes='navbar-signout-button susy-mr-2 susy-ml-2'
                kind='secondary'
            />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    localization: state.localization,
});

export default connect(mapStateToProps)(NavbarSignOutItem);
